var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showFilter
    ? _c(
        "div",
        {
          staticClass: "legal-entity-filter w-full sm:w-auto",
          staticStyle: { "min-width": "260px" },
        },
        [
          _c("label", { staticClass: "text-sm font-medium mb-1 block" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
          _c("v-select", {
            staticClass: "w-full",
            attrs: {
              options: _vm.options,
              reduce: function (option) {
                return option.id
              },
              label: "name",
              placeholder: _vm.placeholder,
              clearable: _vm.isSystemAdmin,
            },
            on: { input: _vm.handleChange },
            model: {
              value: _vm.selected,
              callback: function ($$v) {
                _vm.selected = $$v
              },
              expression: "selected",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }